import { TimeFormatsEnum } from '@wix/calendar-client-library-v3';
import { triggerBIEvent } from '../../../utils';

const calendars = {
  WEEKLY: 'weekly',
  MONTHLY: 'monthly',
  AGENDA: 'agenda',
};
export const addBiEventLiveSite = (type, isAgenda, isWeekly, isMonthly) => {
  let description;
  if (isAgenda) {
    description = isAgenda && calendars.AGENDA;
  } else if (isWeekly) {
    description = isWeekly && calendars.WEEKLY;
  } else if (isMonthly) {
    description = isMonthly && calendars.MONTHLY;
  }

  triggerBIEvent({
    evid: '301',
    type,
    description,
  });
};

export const addBiEventPublish = (state, isConnect, calendarsList) => {
  const {
    isAgenda,
    isWeekly,
    isMonthly,
    isPrivateEventsShown,
    timeFormat,
    isTimeZoneShown,
    isTimeShown,
    isSiteColors,
    weekStarter,
    language,
    isVisitorLocationTimeZone,
    isStretchable,
    isFixedSize,
    alignment,
    calendarsListSelectedLength,
  } = state;

  let wixlabs_string_1;
  if (isAgenda) {
    wixlabs_string_1 = isAgenda && calendars.AGENDA;
  } else if (isWeekly) {
    wixlabs_string_1 = isWeekly && calendars.WEEKLY;
  } else if (isMonthly) {
    wixlabs_string_1 = isMonthly && calendars.MONTHLY;
  }

  let wixlabs_string_7;
  if (isMonthly) {
    wixlabs_string_7 = isStretchable ? 'flexible_ratio' : '1_on_1_ratio';
  } else {
    wixlabs_string_7 = null;
  }

  let wixlabs_string_8;
  if (isAgenda || isWeekly) {
    wixlabs_string_8 = isFixedSize ? 'fixed_size' : 'fit_to_content';
  } else {
    wixlabs_string_8 = null;
  }

  triggerBIEvent({
    evid: '201',
    event_trigger: 'publish',
    wixlabs_bool_1: typeof isConnect === 'boolean' ? isConnect : false,
    wixlabs_bool_2: '',
    wixlabs_bool_3: timeFormat === TimeFormatsEnum.tweleveHours,
    wixlabs_bool_4: isTimeZoneShown,
    wixlabs_bool_5: isAgenda ? null : isTimeShown,
    wixlabs_bool_6: isPrivateEventsShown,
    wixlabs_bool_7: isSiteColors,
    wixlabs_string_1,
    wixlabs_string_2: weekStarter,
    wixlabs_string_3: '',
    wixlabs_string_4: language,
    wixlabs_string_5: isPrivateEventsShown ? 'Private' : '',
    wixlabs_string_6: isVisitorLocationTimeZone
      ? 'visitor_location'
      : 'custom_time_zone',
    wixlabs_string_7,
    wixlabs_string_8,
    wixlabs_string_9: isAgenda ? null : alignment,
    wixlabs_num_1: calendarsListSelectedLength,
    wixlabs_num_2: calendarsList ? calendarsList.length : 0,
  });
};
